import styled from "styled-components"
import { colors, spacing, typography } from "Shared/tokens"

export const Icone = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 0 ${spacing[2]}px;
  color: ${colors.gray[600]};
  font-size: ${typography.bodySmall.size}px;
  cursor: help;
`

/** Texte BRUT : les retours à la ligne saisis sont rendus, aucun HTML n'est interprété. */
export const Texte = styled.div`
  max-width: 320px;
  white-space: pre-line;
  font-size: ${typography.bodySmall.size}px;
  line-height: ${typography.bodySmall.lineHeight};
`
